// src/components/Dashboard_ADM/ui/GlassBackdrop.tsx
// Fundo com manchas suaves (gold + cosmos) fixas no viewport — é isso que dá aos
// painéis translúcidos algo pra desfocar por trás. Sem isso, glassmorphism não lê como vidro.
import React from 'react';

const GlassBackdrop: React.FC = () => (
  <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
    <div className="absolute -top-32 -right-24 w-[440px] h-[440px] rounded-full bg-gold-400/20 blur-[110px]" />
    <div className="absolute top-1/3 -left-40 w-[420px] h-[420px] rounded-full bg-cosmos-700/10 blur-[120px]" />
    <div className="absolute bottom-0 right-1/4 w-[360px] h-[360px] rounded-full bg-gold-300/10 blur-[100px]" />
  </div>
);

export default GlassBackdrop;
